import { render, staticRenderFns } from "./university-and-airport-residential-buildings-in-baghdad.vue?vue&type=template&id=3946aa0c&"
import script from "./university-and-airport-residential-buildings-in-baghdad.vue?vue&type=script&lang=js&"
export * from "./university-and-airport-residential-buildings-in-baghdad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports